import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import CaseStudies from "./CaseStudies";

function WhatisPreIpo() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  return (
    <div>
      <section id="contact" class="contact section">
        {/* Section Title */}
        <div
          class="container section-title"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h2>Why Invest in a Pre-IPO</h2>
          <p>Unlocking Growth Opportunities : Before Public Listing</p>
        </div>
        {/* End Section Title */}

        <div class="container">
          <div class="row gy-4">
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="200">
              <h3>What are Pre-IPO Shares? </h3>
              <h6>
                Pre-IPO shares are equity shares of a company that are available
                for purchase before the company goes public through an Initial
                Public Offering (IPO).
              </h6>
              <h6>
                These shares are typically offered at a discounted rate compared
                to the anticipated IPO price.
              </h6>
              <h6>
                Access to these shares is through Promoters / Venture capital
                companies / Company Employees – ESOPS / Grey markets.
              </h6>
              <h6>
                There is no caping on the number of shares or the size of
                investment as quota rules do not apply to Pre-IPOs.
              </h6>
            </div>
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="300">
              <h3>Key Advantages of Investing in Pre-IPO Shares </h3>
              <h6>
                <strong>Early Entry Opportunity:</strong>&nbsp;Gain access to
                shares at a lower valuation before public listing. (Early move
                advantage)
              </h6>
              <h6>
                <strong>High Growth Potential: </strong>&nbsp; Participate in
                the growth of high-potential companies early in their lifecycle.
              </h6>
              <h6>
                <strong>Diversification: </strong>&nbsp; Pre-IPO shares provide
                exposure to a new asset class and sector diversification.
              </h6>
              <h6>
                <strong>Potential for Higher Returns:</strong>&nbsp; Investors
                can benefit from substantial price appreciation when the company
                goes public.
              </h6>
            </div>
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="400">
              <h3>Key Features of Pre-IPO Investments</h3>
              <h6>
                {" "}
                <strong> Discounted Pricing:</strong> Shares are often priced
                below the expected IPO valuation.
              </h6>
              <h6>
                {" "}
                <strong> Lock-In Period: </strong> Some pre-IPO shares may have
                a lock-in period before they can be sold. SME lock-in is for 12
                months and for main board it is for 6 months.
              </h6>
              <h6>
                {" "}
                <strong> Private Market Risks: </strong> Investments are less
                liquid compared to post-IPO shares.
              </h6>
            </div>
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="500">
              <h3>Trust : Regulatory and Transactional Safeguards</h3>
              <h6>
                <strong>Regulatory Oversight:</strong>&nbsp; All pre-IPO
                investments fall under the purview of SEBI (Securities and
                Exchange Board of India), ensuring compliance with established
                guidelines.
              </h6>
              <h6>
                <strong>Merchant Bank Involvement:</strong>&nbsp; Merchant banks
                act as underwriters for pre-IPO transactions, adhering to RBI
                (Reserve Bank of India) regulations.
              </h6>
              <h6>
                <strong>Secure Transaction Process: </strong>&nbsp; Shares are
                credited directly to your Demat account (CDSL/NDSL). Transfers
                are safeguarded with username, password, and an OTP (One-Time
                Password) mechanism, ensuring safe and seamless transactions.
              </h6>
            </div>
          </div>
        </div>
      </section>
      <CaseStudies/>
    </div>
  );
}

export default WhatisPreIpo;
